import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import useQueryClientCallback from '@/hooks/useQueryClientCallback'
import { updateServicePOCResponse } from '@/modules/Service/services'
import { Service } from '@/modules/Service/types'
import { ModalProps } from '@/types/shared'
import { formatPGDate } from '@/utils/function'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Dialog, GridHookForm } from 'vnetwork-ui'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

export interface ResponsePOCProps extends ModalProps {
    serviceID: number
    service: Partial<Service>
}
const ResponsePOC: React.FC<ResponsePOCProps> = ({
    open,
    onClose,
    service,
    serviceID,
}) => {
    const { t } = useTranslation()
    const formControl = useForm<{
        service_stopped_date: string
        service_update_description: string
    }>({
        defaultValues: {
            service_stopped_date: service?.service_stopped_date,
            service_update_description: '',
        },
    })
    const { refetch } = useQueryClientCallback({
        reactQueryKeys: [
            `services.${serviceID}`,
            `services.updates.${serviceID}`,
        ],
    })

    const { mutateAsync, isPending } = useMutationWithHandler(
        {
            mutationFn: updateServicePOCResponse,
        },
        {
            successMessage: t('update-service-success'),
            reactQueryKeys: QUERY_KEYS.SERVICES,
            onSuccess: () => {
                onClose()
                refetch()
            },
        }
    )

    const onSubmit = async (values: {
        service_stopped_date: string
        service_update_description: string
    }) => {
        mutateAsync({
            serviceID,
            data: {
                ...values,
                service_stopped_date: formatPGDate(
                    values?.service_stopped_date,
                    'YYYY-MM-DD'
                ),
            },
        })
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('service-response-of-poc')}
        >
            <GridHookForm
                onSubmit={onSubmit}
                actions={[
                    {
                        title: t('cancel'),
                        type: 'submit',
                        handler: onClose,
                        disabled: isPending,
                        variant: 'outlined',
                    },
                    {
                        title: t('submit'),
                        type: 'submit',
                        disabled: isPending,
                        loading: isPending,
                        variant: 'contained',
                    },
                ]}
                data={[
                    {
                        formItemProps: {
                            name: 'service_stopped_date',
                            type: 'datepicker',
                            label: t('service_stopped_date'),
                        },
                        className: 'col-span-4',
                    },
                    {
                        formItemProps: {
                            name: 'service_update_description',
                            type: 'textarea',
                            label: t('service_update_description'),
                            placeholder:
                                t('service_update_description') + '...',
                        },
                        className: 'col-span-4',
                    },
                ]}
                formControl={formControl}
            />
        </Dialog>
    )
}

export default ResponsePOC
